import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IActionTaken from '../interfaces/IActionTaken';


export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue, getValues} = useForm<IActionTaken>();
  const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'name', type: 'string'},
  ];
  
    return(
      <CrudEdit 
        model={'action-taken'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Action taken successfully updated!'}  
        title={'Edit action taken'}
        getValues={getValues} 
      />
    )
}
